(function() {

    function cookieHandling() {
        let container = document.querySelector('.cookieInfo'),
            cookie = localStorage.getItem('tofuCookies'),
            close = document.querySelector('.closeCookies');

        if(container) {
            if(!cookie) {
                TweenMax.fromTo(container, 0.6, {visibility: "visible", opacity: 0}, {opacity: 1});

                close.addEventListener('click', function() {
                    localStorage.setItem('tofuCookies', true);
                    TweenMax.to(container, 0.6, {opacity: 0});
                    container.classList.add('accepted');
                })
            }
        }
    }

    window.addEventListener('load', function() {
        cookieHandling();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/cookies.js
// module id = 3
// module chunks = 0